import { apiCall } from './gqlClient';
const GETPENDINGCUSTOMERS_QUERY = "\n  query getPendingCustomers {\n    getPendingCustomers\n  }";
export const getPendingCustomersApiCall = async () => apiCall({
  query: GETPENDINGCUSTOMERS_QUERY,
  variables: {}
});
const CHECKFORPENDINGCUSTOMERS_QUERY = "\n  query checkForPendingCustomers {\n    checkForPendingCustomers\n  }";
export const checkForPendingCustomersApiCall = async () => apiCall({
  query: CHECKFORPENDINGCUSTOMERS_QUERY,
  variables: {}
});
const APPROVECUSTOMER_QUERY = "\n  mutation approveCustomer($userId: Int!) {\n    approveCustomer(userId: $userId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const approveCustomerApiCall = async function (_ref) {
  let {
    userId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: APPROVECUSTOMER_QUERY,
    variables: {
      userId
    },
    fragments
  });
};